// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILinkTokenResponseDto
 */
export interface ILinkTokenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ILinkTokenResponseDto
     */
    link_token?: string;
}

/**
 * Check if a given object implements the ILinkTokenResponseDto interface.
 */
export function instanceOfILinkTokenResponseDto(value: object): value is ILinkTokenResponseDto {
    return true;
}

export function ILinkTokenResponseDtoFromJSON(json: any): ILinkTokenResponseDto {
    return ILinkTokenResponseDtoFromJSONTyped(json, false);
}

export function ILinkTokenResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILinkTokenResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'link_token': json['link_token'] == null ? undefined : json['link_token'],
    };
}

export function ILinkTokenResponseDtoToJSON(json: any): ILinkTokenResponseDto {
    return ILinkTokenResponseDtoToJSONTyped(json, false);
}

export function ILinkTokenResponseDtoToJSONTyped(value?: ILinkTokenResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'link_token': value['link_token'],
    };
}

